import {
  DollarCircleFilled,
  ExclamationCircleOutlined,
  FallOutlined,
  LoadingOutlined,
  RiseOutlined,
} from '@ant-design/icons'
import { addCommasToNumber, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React, { useEffect, useState } from 'react'
import { useFormatter } from '@api/useFormatter'

export function PricePerformance({ directiveMetrics, metricsLoading }) {
  const [cardStatus, setCardStatus] = useState()

  useEffect(() => {
    setCardStatus(getCardStatus(directiveMetrics))
  }, [directiveMetrics])

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)

  if (metricsLoading) {
    return (
      <Vertical background='theme-color-2-dim' verticalCenter flex={1.5}>
        <Horizontal>
          <Vertical className='pl-3' horizontalCenter>
            <Texto category='h4' appearance='secondary'>
              <LoadingOutlined />
            </Texto>
          </Vertical>
          <Vertical className='pr-4' verticalCenter>
            <Texto category='h5' align='right' weight='bold' appearance='secondary'>
              Grabbing Price Info
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>
    )
  }

  if (!cardStatus) return null
  return (
    <Vertical background={cardStatus.background} verticalCenter className='py-3 px-4' flex={3}>
      <Vertical>
        <Horizontal verticalCenter>
          <Texto weight='bold' style={{ color: 'var(--gray-600)' }} className='pr-3' appearance='medium'>
            PRICE PERFORMANCE
          </Texto>
          <Horizontal flex={1} justifyContent='flex-start'>
            <Texto align='left' category='h5' weight='bold' className='pr-2' appearance={cardStatus.appearance}>
              <DollarCircleFilled className='pr-2' />
              {cardStatus.status}
            </Texto>
          </Horizontal>
          <Texto weight='bold' className='pr-2' style={{ color: 'var(--gray-600)' }} align='right' appearance='medium'>
            NET VALUE:
          </Texto>
          <Texto weight='bold' align='right' category='h4' appearance={cardStatus.appearance}>
            {formattedCurrency}
            {addCommasToNumber(
              directiveMetrics.total_best_price_days_cost + directiveMetrics.total_not_best_price_days_cost,
              2
            )}
          </Texto>
        </Horizontal>
        <Horizontal className='mt-2 pt-2' border='top'>
          <Horizontal flex={1} verticalCenter>
            <Texto weight='bold' category='h4' appearance='success'>
              <RiseOutlined className='pr-3' />
            </Texto>
            <Vertical>
              <Texto className='flex-1' weight='bold' category='h6' appearance='success'>
                {formattedCurrency}
                {addCommasToNumber(directiveMetrics.total_best_price_days_cost, 2)}
              </Texto>
              <Texto className='flex-1' category='p2'>
                {directiveMetrics.best_price_days} Days
              </Texto>
            </Vertical>
          </Horizontal>
          <Horizontal flex={1} justifyContent='flex-end' verticalCenter>
            <Texto weight='bold' category='h4' appearance='error'>
              <FallOutlined className='pr-3' />
            </Texto>
            <Vertical>
              <Texto className='flex-1' weight='bold' category='h6' appearance='error'>
                {formattedCurrency}
                {addCommasToNumber(directiveMetrics.total_not_best_price_days_cost, 2)}
              </Texto>
              <Texto className='flex-1' category='p2'>
                {directiveMetrics.not_best_price_days} Days
              </Texto>
            </Vertical>
          </Horizontal>
          {directiveMetrics.no_price_days !== 0 && (
            <Horizontal verticalCenter className='pr-2'>
              <Texto category='h4' className='pr-3'>
                <ExclamationCircleOutlined className='pr-1' />
              </Texto>

              <Vertical>
                <Texto className='flex-1' weight='bold' category='h5' appearance='medium'>
                  {directiveMetrics.no_price_days} Days
                </Texto>
                <Texto className='flex-1' category='h6' appearance='medium'>
                  No Prices
                </Texto>
              </Vertical>
            </Horizontal>
          )}
        </Horizontal>
      </Vertical>
    </Vertical>
  )
}
const getCardStatus = (directiveMetrics) => {
  let newStatus = {}
  if (!directiveMetrics) return newStatus
  const isBest = directiveMetrics.total_best_price_days_cost > Math.abs(directiveMetrics.total_not_best_price_days_cost)
  const isEmpty = directiveMetrics.total_days === directiveMetrics.no_price_days
  const noLoaded = directiveMetrics.total_best_price_days_cost + directiveMetrics.total_not_best_price_days_cost === 0

  if (isEmpty) {
    newStatus = {
      background: 'gray-200',
      appearance: 'medium',
      status: 'No Price Data',
    }
  } else if (noLoaded) {
    newStatus = {
      background: 'gray-200',
      appearance: 'medium',
      status: 'No Volume',
    }
  } else if (isBest) {
    newStatus = {
      background: 'theme-success-dim',
      appearance: 'success',
      status: 'Good',
    }
  } else {
    newStatus = {
      background: 'theme-error-dim',
      appearance: 'error',
      status: 'Poor',
    }
  }
  return newStatus
}
